"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("core-js/modules/es6.function.name");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _activityCreationApi = require("@/api/activityCreationApi");
var _ossUpload = require("@/utils/ossUpload");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ActivityPupop',
  data: function data() {
    return {
      pickerOptions: {
        shortcuts: [{
          text: '长期有效',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            end.setTime(start.getTime() + 3600 * 1000 * 24 * 3600);
            start.setHours(0, 0, 0, 0); // 设置为00:00:00
            end.setHours(23, 59, 59, 999); // 设置为23:59:59
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      dialogVisible: false,
      ruleForm: {
        region: '',
        name: '',
        color: '',
        type: 0,
        id: '',
        imageUrl: '',
        promoteDesc: '',
        date: '',
        jumpType: 2 // 活动类型
        // appId: 0
      },
      rules: {
        region: [{
          required: true,
          message: '请选择平台类型',
          trigger: 'change'
        }],
        name: [{
          required: true,
          message: '请输入活动名称',
          trigger: 'blur'
        }],
        color: [{
          required: true,
          message: '请输入背景色值',
          trigger: 'blur'
        }],
        promoteDesc: [{
          required: true,
          message: '请输入推广素材文案',
          trigger: 'blur'
        }],
        id: [{
          required: true,
          message: '请输入活动ID/URL',
          trigger: 'blur'
        }],
        imageUrl: [{
          required: true,
          message: '请输上传图片',
          trigger: 'blur'
        }],
        date: [{
          required: true,
          message: '请选择日期',
          trigger: 'change'
        }],
        type: [{
          required: true,
          message: '请选择活动资源',
          trigger: 'change'
        }]
      },
      // imageUrl: '', // 图片展示
      controlsType: '',
      // 编辑,添加
      activityId: '' // 活动id
    };
  },
  methods: {
    formatDate: function formatDate(d) {
      var date = new Date(d);
      var YY = date.getFullYear() + '-';
      var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      var DD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
      var ss = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      return YY + MM + DD + ' ' + hh + mm + ss;
    },
    open: function open(type, id) {
      this.controlsType = type; // 操作类型
      this.dialogVisible = true; // 弹窗开关
      if (type === 'add') {
        var end = new Date();
        var start = new Date();
        end.setTime(start.getTime() + 3600 * 1000 * 24 * 3600);
        start.setHours(0, 0, 0, 0); // 设置为00:00:00
        end.setHours(23, 59, 59, 999); // 设置为23:59:59
        this.ruleForm.date = [this.formatDate(start), this.formatDate(end)];
        // this.dialogVisible = true
      } else if (type === 'editor') {
        this.getActivityApi(id);
      }
    },
    // 活动查询
    getActivityApi: function () {
      var _getActivityApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(id) {
        var params, res, data, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              params = {
                id: id
              };
              _context.n = 1;
              return (0, _activityCreationApi.getActivityApi)(params);
            case 1:
              res = _context.v;
              if (res.code === 0) {
                data = res.data;
                this.ruleForm.region = data.unionCode;
                this.ruleForm.name = data.name;
                this.ruleForm.color = data.colorValue;
                this.ruleForm.type = data.type;
                this.ruleForm.promoteDesc = data.promoteDesc;
                if (data.type === 0) {
                  this.ruleForm.id = data.unionActivityId;
                } else {
                  this.ruleForm.id = data.unionActivityLink;
                }
                this.ruleForm.imageUrl = data.mainImage;
                this.ruleForm.date = [data.startTime, data.endTime];
                this.activityId = data.id;
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getActivityApi(_x) {
        return _getActivityApi2.apply(this, arguments);
      }
      return getActivityApi;
    }(),
    handleClose: function handleClose() {
      this.dialogVisible = false;
      this.resetForm('ruleForm');
    },
    // 提交
    submitForm: function submitForm(formName) {
      var _this = this;
      console.log('this.ruleForm---', this.ruleForm.date);
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          if (_this.controlsType === 'add') {
            _this.saveActivityApi();
          } else {
            _this.updateActivityApi();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 重置
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
      this.ruleForm = {
        region: '',
        name: '',
        color: '',
        type: 0,
        id: '',
        promoteDesc: '',
        imageUrl: '',
        date: '',
        // appId: 0,
        jumpType: 2 // 活动类型
      };
    },
    // 图片上传
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      // this.imageUrl = URL.createObjectURL(file.raw)
    },
    handleFileUpload: function () {
      var _handleFileUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2(_ref) {
        var file, pictureUrl, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              file = _ref.file;
              _context2.p = 1;
              _context2.n = 2;
              return (0, _ossUpload.uploadOSS)(file);
            case 2:
              pictureUrl = _context2.v;
              this.ruleForm.imageUrl = pictureUrl;
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              console.log('error ->', _t2);
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3]]);
      }));
      function handleFileUpload(_x2) {
        return _handleFileUpload.apply(this, arguments);
      }
      return handleFileUpload;
    }(),
    // 添加活动
    saveActivityApi: function () {
      var _saveActivityApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var params, res, _t3;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              params = {
                // 'userId': 0,
                'unionCode': this.ruleForm.region,
                // 联盟编码
                'name': this.ruleForm.name,
                // 	活动名称
                'colorValue': this.ruleForm.color,
                //	背景色值
                'type': this.ruleForm.type,
                // 	联盟活动类型
                'unionActivityId': '',
                // 	联盟活动Id
                'unionActivityLink': '',
                // 联盟活动链接
                'mainImage': this.ruleForm.imageUrl,
                // 	活动页头图
                'promoteDesc': this.ruleForm.promoteDesc,
                // 推广文案
                'startTime': this.ruleForm.date[0],
                // 	活动开始时间
                'endTime': this.ruleForm.date[1],
                // 活动结束时间
                appId: 0,
                jumpType: 2 // 活动类型
              };
              if (this.ruleForm.type === 0) {
                params.unionActivityId = this.ruleForm.id;
              } else {
                params.unionActivityLink = this.ruleForm.id;
              }
              console.log('params', params);
              _context3.n = 1;
              return (0, _activityCreationApi.saveActivityApi)(params);
            case 1:
              res = _context3.v;
              if (res.code === 0) {
                this.dialogVisible = false;
                this.$emit('refresh');
                this.resetForm('ruleForm');
                this.$notify.success({
                  title: '温馨提示',
                  message: '新增成功'
                });
              }
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              console.log(_t3);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function saveActivityApi() {
        return _saveActivityApi2.apply(this, arguments);
      }
      return saveActivityApi;
    }(),
    // 编辑
    updateActivityApi: function () {
      var _updateActivityApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4() {
        var params, res, _t4;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              params = {
                // 'userId': 0,
                'unionCode': this.ruleForm.region,
                // 联盟编码
                'name': this.ruleForm.name,
                // 	活动名称
                'colorValue': this.ruleForm.color,
                //	背景色值
                'type': this.ruleForm.type,
                // 	联盟活动类型
                'unionActivityId': '',
                // 	联盟活动Id
                'unionActivityLink': '',
                // 联盟活动链接
                'mainImage': this.ruleForm.imageUrl,
                // 	活动页头图
                'promoteDesc': this.ruleForm.promoteDesc,
                // 推广文案
                'startTime': this.ruleForm.date[0],
                // 	活动开始时间
                'endTime': this.ruleForm.date[1],
                // 活动结束时间
                // appId: 0,
                jumpType: 2 // 活动类型
              };
              if (this.ruleForm.type === 0) {
                params.unionActivityId = this.ruleForm.id;
              } else {
                params.unionActivityLink = this.ruleForm.id;
              }
              params.id = this.activityId;
              _context4.n = 1;
              return (0, _activityCreationApi.updateActivityApi)(params);
            case 1:
              res = _context4.v;
              if (res.code === 0) {
                this.dialogVisible = false;
                this.$emit('refresh');
                this.resetForm('ruleForm');
                this.$notify.success({
                  title: '温馨提示',
                  message: '编辑成功'
                });
              }
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t4 = _context4.v;
              console.log(_t4);
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function updateActivityApi() {
        return _updateActivityApi2.apply(this, arguments);
      }
      return updateActivityApi;
    }()
  }
};